import React, { useEffect, useState } from 'react';
import useAxios from "../../hooks/useAxios";
import Error from '../Error/Error';
import Loading from '../Loading/Loading';
import './Tile.css';
import { useNavigate } from 'react-router-dom';
import { useService } from '../../context/ServiceProvider';
import { useMsal } from "@azure/msal-react";
import { loginRequest } from '../../config/authConfig';

interface Props {
  name: string,
  url: string,
  type: string,
  detailsUrl: string,
}

const Tile: React.FC<Props> = ({ name, url, type, detailsUrl }) => {
  const { currentService } = useService()
  const [token, setToken] = useState<string | null>(null);
  const { instance, accounts } = useMsal();

  const { response, error, loading, fetchData } = useAxios(currentService?.apiBaseUrl || "", token ?? undefined);

  useEffect(() => {
    const getToken = async () => {
      if (accounts.length === 0) return;

      try {
        const result = await instance.acquireTokenSilent({
          ...loginRequest,
          account: accounts[0],
        });
        setToken(result.accessToken);
      } catch (err) {
        console.error("Failed to acquire token silently:", err);
      }
    };

    getToken();
  }, [accounts, instance]);

  useEffect(() => {
    if (!token) return;
    fetchData({ url, method: "GET" });
  }, [url, token, fetchData]);
  const navigate = useNavigate();

  const apiResponse: number = response;

  const routeToDetails = () => {
    navigate(`/detail/${type}/${encodeURIComponent(name)}`, {
      state: {
        type: type,
        label: name,
        apiUrl: detailsUrl,
      },
    });
  }

  if (loading) return <Loading label={name} />
  if (error) return <Error error={error} />

  return (
    <div className="tile" onClick={routeToDetails}>
      <div className="tile-name">{name} Teams</div>
      {apiResponse !== null && response !== undefined ? (
        <div className="tile-count">{apiResponse}</div>

      ) : (
        <p>No data available for {name}</p>
      )}
    </div>
  );
};

export default Tile;
